import React from 'react';
import { Flex, Box, useBreakpoint } from '@landr/maestro';
import { token } from '@landr/styled-system/tokens';

const rowHeight = token('spacing.xl');
const rowGap = token('spacing.xs');

const oneLineHeight = rowHeight;
const threeLinesHeight = `calc(3 * ${rowHeight} + 2 * ${rowGap})`;
const sevenLinesHeight = `calc(7 * ${rowHeight} + 6 * ${rowGap})`;

export const Wrapper = ({
    children,
    containerRef,
    overflowRef,
    isOpen,
}: {
    children: React.ReactNode;
    containerRef: React.RefObject<HTMLDivElement>;
    overflowRef: React.RefObject<HTMLDivElement>;
    isOpen: boolean;
}) => {
    const isMobile = useBreakpoint('md');
    const closeHeight = isMobile ? threeLinesHeight : oneLineHeight;
    const openHeight = isMobile ? sevenLinesHeight : threeLinesHeight;

    return (
        <Box
            marginTop="xl"
            ref={containerRef}
            data-suggestions-pills-container
            style={{
                position: 'relative',
                overflow: 'visible',
            }}
        >
            <Box
                ref={overflowRef}
                data-suggestions-pills-overflow
                style={{
                    width: '100%',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 'auto',
                    height: closeHeight,
                    overflow: 'visible',
                }}
            ></Box>
            <Flex
                flexWrap="wrap"
                gap="xs"
                style={{
                    position: 'relative',
                    maxHeight: isOpen ? openHeight : closeHeight,
                    overflow: 'hidden',
                    alignItems: 'flex-start',
                    alignContent: 'flex-start',
                }}
            >
                {children}
            </Flex>
        </Box>
    );
};
